import { FlatBookingPlansSpecification } from '../../flat-booking-plans/flat-booking-plans-spec/flat-booking-plans-specification';

export const CommercialBookingPlansSpecification = {
  ...FlatBookingPlansSpecification,
  invitationsDetails: [
    '+COMMERCIAL_BOOKING.PLAN.BASIC.FEATURE.INVITATIONS.SERVICE_COMPANIES',
    '+COMMERCIAL_BOOKING.PLAN.BASIC.FEATURE.INVITATIONS.END_CUSTOMERS',
    '+COMMERCIAL_BOOKING.PLAN.BASIC.FEATURE.INVITATIONS.ACCEPT_INVITATIONS',
  ],
};
